import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16933 15690"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528313124784">
        <path
          d="M15604 15690c-89 0-160-71-160-159V2222H1489v13309c0 88-71 159-159 159s-159-71-159-159V2063c0-89 71-159 159-159h14272c88 0 159 70 159 159v13468c2 88-71 159-157 159z"
          className="fil0"
        />
        <path
          d="M15823 2222H1111C499 2222 0 1723 0 1111S499 0 1111 0h14712c613 0 1110 499 1110 1111s-498 1111-1110 1111zM1111 318c-437 0-793 356-793 793 0 438 356 793 793 793h14712c437 0 792-355 792-793 0-437-355-793-792-793H1111z"
          className="fil0"
        />
        <path
          d="M14784 6507H4342c-42 0-82-18-113-46-1781-1765-1314-4321-1293-4429 13-75 80-128 155-128h10442c48 0 92 21 123 57 31 37 42 84 33 131-4 24-453 2498 1205 4142 46 46 59 114 34 173-21 61-78 100-144 100zM4408 6190h10012c-1259-1479-1146-3367-1069-3968H3231c-67 526-215 2541 1177 3968z"
          className="fil0"
        />
        <path
          d="M14784 10793H4342c-42 0-82-17-113-46-1781-1767-1314-4321-1293-4430 13-75 80-129 155-129h10442c48 0 92 21 123 58 31 36 42 84 33 130-4 25-453 2499 1205 4143 46 46 59 113 34 173-21 63-78 101-144 101zm-10376-316h10012c-1259-1482-1146-3368-1069-3968H3231c-67 525-215 2540 1177 3968z"
          className="fil0"
        />
        <path
          d="M14784 15080H4342c-42 0-82-17-113-46-1781-1767-1314-4321-1293-4429 13-75 80-128 155-128h10442c48 0 92 21 123 57 31 37 42 85 33 133-4 25-453 2498 1205 4142 46 46 59 114 34 173-21 60-78 98-144 98zm-10376-319h10012c-1259-1479-1146-3367-1069-3968H3231c-67 528-215 2543 1177 3968z"
          className="fil0"
        />
        <path
          d="M4342 15080H3030c-88 0-159-71-159-159V2063c0-89 71-159 159-159s159 70 159 159v12700h1153c89 0 160 71 160 160 0 86-71 157-160 157z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
